import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

import { OptionalAsyncPipe } from '../../../pipes/OptionalAsync.pipe';
import type { Icon } from '../../../types/icon-list.type';
import { icons } from '../../../types/icon-list.type';
import { MenuItemType } from '../../../types/menu-item.type';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'evc-collapsible-panel',
  imports: [IconComponent, OptionalAsyncPipe],
  templateUrl: './collapsible-panel.component.html',
  styleUrls: ['./collapsible-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsiblePanelComponent {
  readonly isOpenStateChange = output<boolean>();
  readonly content = input<MenuItemType>();
  readonly isOpen = signal(false);

  toggleCollapsible(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen.update((open) => !open);
    this.isOpenStateChange.emit(this.isOpen());
  }

  getIcon(): Icon {
    return this.isOpen() ? icons.CHEVRON_UP : icons.CHEVRON_DOWN;
  }
}
